import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  DialogTitle,
} from "@mui/material";
import Button from "../../components/Button/Button";
import { Save } from "@mui/icons-material";
import {
  change_admin_password,
  edit_admin_role,
  get_admin_detail,
  get_return_status,
  get_role,
  get_sales_order_report,
  get_sales_rep_report,
  superadmin_change_password,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";

export default function AdminDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);
  const [page, setPage] = useState("User Information");
  const [roleList, setRoleList] = React.useState(null);
  const [selectedRole, setSelectedRole] = React.useState("");

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [loading, setLoading] = React.useState(false);
  const [adminDetail, setAdminDetail] = React.useState(null);
  const [adminHistory, setAdminHistory] = React.useState(null);

  const getData = () => {
    setLoading(true);
    get_admin_detail({
      admin_id: params.admin_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setAdminDetail(json.data);
      setSelectedRole(json.data.role_id);
      // setTotalList(json.total);
    });
    get_role({}).then((resRole) => {
      setRoleList(resRole.data);
    });
  };
  const [password, setPassword] = useState({
    password: "",
    password2: "",
    admin_id: "",
  });

  const handleChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePassword = () => {
    if (password.password.length === 0) {
      toast("Please enter new password");
      return;
    }
    if (password.password2.length === 0) {
      toast("Please enter new confirm password");
      return;
    }
    var data = {
      ...password,
      admin_id: params.admin_id,
    };
    superadmin_change_password(data).then((json) => {
      if (json.status) {
        toast("Password Changed");
      } else {
        toast(json.message);
      }
    });
    // if (loginData.email.length == "" || loginData.password.length == "") {
    //   alert("All Field Required");
    //   return;
    // }

    // login(loginData).then((json) => {
    //   if (json.status) {
    //     alert(json.message);
    //     navigate("/dashboard");
    //   } else {
    //     alert(json.message);
    //   }
    // });
  };

  React.useEffect(() => {
    getData();
  }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const handleSaveDetail = (e) => {
    var data = {
      role_id: selectedRole,
      admin_id: params.admin_id,
    };
    if (window.confirm("Are you sure you want to edit role?")) {
      edit_admin_role(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Admin Detail Edit Successful");
          getData();
        } else {
          // setLoadingAdd(false);
          // toast(res.messege)
        }
      });
    }
  };

  // SALE REPORT

  const [sortSaleReport, setSortSaleReport] = React.useState(0);
  const [allData, setAllData] = React.useState([]);

  const handleChangeSortSaleReport = (event) => {
    setSort(event.target.value);
  };

  const [searchKeySaleReport, setSearchKeySaleReport] = React.useState("");
  // const [searchKeyStatus, setSearchKeyStatus] = React.useState("");

  const searchData = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].sales_order_id
            .toUpperCase()
            .indexOf(searchKey.toUpperCase()) > -1
        ) {
          _data.push(data[i]);
        }
      }
    } else {
      _data = [...data];
    }

    return _data;
  };

  const handleSearchSaleReport = (event) => {
    setSearchKey(event.target.value);
    var _data = searchData(allData, event.target.value);
    setListData(_data);
    setPageNum(0);
    setTotalListSaleReport(_data.length);
  };

  const [returnStatus, setReturnStatus] = React.useState([]);

  const getStatus = () => {
    get_return_status().then((json) => {
      setReturnStatus(json.data);
    });
  };

  React.useEffect(() => {
    getStatus();
  }, []);
  const [selectedStatus, setSelectedStatus] = React.useState("Open");

  const handleChooseStatus = (e) => {
    setSelectedStatus(e.target.value);
    window.localStorage.setItem("issuelog_status", e.target.value);
  };

  const [dateFrom, setDateFrom] = React.useState("");

  const handleChangeDateFrom = (event) => {
    const value = event.target.value;
    setDateFrom(value);
    window.localStorage.setItem("issuelog_datefrom", value);
  };

  const [dateTo, setDateTo] = React.useState("");

  const handleChangeDateTo = (event) => {
    const value = event.target.value;
    setDateTo(value);
    window.localStorage.setItem("issuelog_dateto", value);
  };

  // const [loading, setLoading] = React.useState(false);
  const [totalListSaleReport, setTotalListSaleReport] = React.useState(1);
  const [pageNumSaleReport, setPageNumSaleReport] = React.useState(0);
  const [imageData, setImageData] = React.useState(null);
  const [openVariantImg, setOpenVariantImg] = React.useState(false);
  const [infiniteStatus, setInfiniteStatus] = React.useState(true);

  const handleOpenVariantImage = (e) => {
    // console.log(e)
    if (e.length < 5) {
      setInfiniteStatus(false);
    } else {
      setInfiniteStatus(true);
    }
    setOpenVariantImg(true);
    setImageData(e);
  };
  const handleCloseVariantImage = (value) => {
    setOpenVariantImg(false);
    setImageData(null);
  };

  const [listData, setListData] = React.useState(null);

  const getDataSaleReport = () => {
    setLoading(true);
    get_sales_rep_report({
      page: 1,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: selectedStatus,
      admin_id: params.admin_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setAllData(json.data);
      var _data = searchData(json.data, searchKey);
      setListData(_data);
      setTotalListSaleReport(_data.length);
    });
  };

  React.useEffect(() => {
    getDataSaleReport();
    const storedStatus = window.localStorage.getItem("issuelog_status");
    if (storedStatus) {
      setSelectedStatus(storedStatus);

      const storedDateFrom = window.localStorage.getItem("issuelog_datefrom");
      if (storedDateFrom) {
        setDateFrom(storedDateFrom);
      }
      const storedDateTo = window.localStorage.getItem("issuelog_dateto");
      if (storedDateTo) {
        setDateTo(storedDateTo);
      }
    }
  }, [pageNumSaleReport, sortSaleReport, dateFrom, dateTo, selectedStatus]);

  const handleChangePageSaleReport = (e, ispage) => {
    setPageNumSaleReport(ispage);
    // getData();
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#707070" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {adminDetail != null && (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#000"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#000" bold="600" size="24px">
                        User Detail
                      </Paragraph>

                      {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
															<a
																	className={classes.theCustomActionBtn}
															// onClick={() => handleOpenStockMove()}
															>
																	<AddCircle sx={{ color: "#707070" }} />
																	<Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
															</a>
															<a
																	className={classes.theCustomActionBtn_}
															// onClick={() => handleOpenStockMove()}
															>
																	<ExitToApp sx={{ color: "#707070" }} />
																	<Paragraph margin="0 0 0 .4rem">Export</Paragraph>
															</a>
													</div> */}
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <div className={classes.theFlexAction}>
                      <div
                        className={
                          page === "User Information"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => setPage("User Information")}
                      >
                        <Paragraph>User Information</Paragraph>
                      </div>

                      <div
                        className={
                          page === "Sales Report"
                            ? classes.theCustomActionBtnFill_
                            : classes.theCustomActionBtnInFill_
                        }
                        onClick={() => setPage("Sales Report")}
                      >
                        <Paragraph>Sales Report</Paragraph>
                      </div>
                      {/* <div
														className={page === "Order History" ? classes.theCustomActionBtnFill_ : classes.theCustomActionBtnInFill_}
														onClick={() => setPage("Order History")}
													>
                          <Paragraph>Order History</Paragraph>
                        </div> */}
                      {/* <div
													className={page === "Wallet" ? classes.theCustomActionBtnFill_ : classes.theCustomActionBtnInFill_}
													onClick={() => setPage("Wallet")}
												>
													<Paragraph>Wallet</Paragraph>
												</div> */}
                    </div>
                    <br />
                    {page === "User Information" && (
                      <React.Fragment>
                        <Card className={classes.theCard_}>
                          <div className={classes.theCHeader}>
                            <Paragraph
                              color="#000"
                              bold="600"
                              size="16px"
                              // margin="0 0 1rem"
                            >
                              General Information
                            </Paragraph>
                          </div>
                          <div className={classes.theCBody}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={2}>
                                <Paragraph size="14px">Name:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <Paragraph size="14px" bold="600">
                                  {adminDetail.name != "" &&
                                  adminDetail.name != null
                                    ? adminDetail.name
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={2}>
                                <Paragraph size="14px">
                                  Contact Number:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <Paragraph size="14px" bold="600">
                                  {adminDetail.contact != "" &&
                                  adminDetail.contact != null
                                    ? adminDetail.contact
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={2}>
                                <Paragraph size="14px">Email:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <Paragraph size="14px" bold="600">
                                  {adminDetail.email != "" &&
                                  adminDetail.email != null
                                    ? adminDetail.email
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <div
                                  style={{
                                    width: "50%",
                                  }}
                                >
                                  <FormInput
                                    label="Role"
                                    value={selectedRole}
                                    textcolor="#707070"
                                    placeholder="Class"
                                    name="class"
                                    bg="#fff"
                                    border="1px solid #c5c5c5"
                                    select
                                    onChange={(e) =>
                                      setSelectedRole(e.target.value)
                                    }
                                  >
                                    {roleList != null &&
                                      roleList.map((res) => (
                                        <MenuItem
                                          value={res.role_id}
                                          style={{ color: "#000" }}
                                        >
                                          {res.name}
                                        </MenuItem>
                                      ))}
                                  </FormInput>
                                </div>
                              </Grid>
                            </Grid>

                            <div
                              className={classes.theFlexBtn}
                              style={{ marginBottom: "0" }}
                            >
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleSaveDetail()}
                                >
                                  <Save sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Save
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            </div>
                          </div>
                        </Card>
                        <br />
                        <Card className={classes.theCard_}>
                          <div className={classes.theCHeader}>
                            <Paragraph
                              color="#000"
                              bold="600"
                              size="16px"
                              // margin="0 0 1rem"
                            >
                              Reset Password
                            </Paragraph>
                          </div>
                          <div className={classes.theCBody}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={2}>
                                <Paragraph size="14px">
                                  New Password*:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <FormInput
                                  // label='New Password*'
                                  textcolor="#707070"
                                  placeholder="New Password"
                                  name="password"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  type="password"
                                  onChange={handleChange}
                                ></FormInput>
                              </Grid>
                              <Grid item xs={12} sm={4} md={2}>
                                <Paragraph size="14px">
                                  Confirm New Password*:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={10}>
                                <FormInput
                                  textcolor="#707070"
                                  placeholder="Confirm New Password"
                                  name="password2"
                                  bg="#fff"
                                  border="1px solid #c5c5c5"
                                  type="password"
                                  onChange={handleChange}
                                ></FormInput>
                              </Grid>
                            </Grid>

                            <div
                              className={classes.theFlexBtn}
                              style={{ marginBottom: "0" }}
                            >
                              <React.Fragment>
                                <a
                                  style={{ backgroundColor: "#1A8649" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleChangePassword()}
                                >
                                  <Save sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Save
                                  </Paragraph>
                                </a>
                              </React.Fragment>
                            </div>
                          </div>
                        </Card>

                        {/* <Card className={classes.theCard_}>
                                            <div className={classes.theCHeader}>
                                                <Paragraph
                                                    color="#000"
                                                    bold="600"
                                                    size="16px"
                                                // margin="0 0 1rem"
                                                >
                                                    Billing & Shipping Address
                                                </Paragraph>
                                            </div>
                                            <div className={classes.theCBody}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <Paragraph size="14px" margin="0 0 0.5rem">Billing Address:</Paragraph>
                                                        <Paragraph size="14px" bold="600">Lestk Sdn Bhd</Paragraph>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <Paragraph size="14px" margin="0 0 0.5rem">Shipping Address:</Paragraph>
                                                        <Paragraph size="14px" bold="600" margin="0 0 0.5rem">Lestk Sdn Bhd</Paragraph>
                                                        <Paragraph size="14px" bold="600" margin="0 0 0.5rem">Lestk Sdn Bhd</Paragraph>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Card> */}
                      </React.Fragment>
                    )}
                    {page === "Order History" && (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <TableContainer>
                              <Table>
                                <TableHead
                                  style={{ backgroundColor: "#707070" }}
                                >
                                  <TableRow>
                                    <TableCell
                                      style={{ borderRadius: "10px 0 0 10px" }}
                                      className={classes.theHeadTitle}
                                    >
                                      <Checkbox
                                        sx={{
                                          color: "#fff",
                                          "&.Mui-checked": {
                                            color: "#fff",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Name
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Contact Number
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Email
                                    </TableCell>
                                    <TableCell className={classes.theHeadTitle}>
                                      Credit Limit
                                    </TableCell>
                                    <TableCell
                                      style={{ borderRadius: "0 10px 10px 0" }}
                                      className={classes.theHeadTitle}
                                    >
                                      Balance
                                    </TableCell>
                                    {/* <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                            Amount
                                                        </TableCell> */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {adminHistory != null &&
                                    adminHistory.map((item, index) => {
                                      if (searchKey != "") {
                                        if (
                                          item.entityid
                                            .toUpperCase()
                                            .indexOf(searchKey.toUpperCase()) <=
                                          -1
                                        ) {
                                          return;
                                        }
                                      }
                                      return (
                                        <TableRow>
                                          <a
                                            style={{ display: "contents" }}
                                            // href={`../saledetail/${item.sales_order_id}`}
                                          >
                                            <TableCell>
                                              <Checkbox
                                                sx={{
                                                  color: "#000",
                                                  "&.Mui-checked": {
                                                    color: "#000",
                                                  },
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                textDecoration: "underline",
                                              }}
                                              onClick={() =>
                                                navigate(
                                                  "/customerdetail/" +
                                                    item.customer_id
                                                )
                                              }
                                            >
                                              {item.entityid}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/customerdetail/" +
                                                    item.customer_id
                                                )
                                              }
                                            >
                                              {item.phone}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/customerdetail/" +
                                                    item.customer_id
                                                )
                                              }
                                            >
                                              {item.email}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/customerdetail/" +
                                                    item.customer_id
                                                )
                                              }
                                            >
                                              RM{item.creditlimit}
                                            </TableCell>
                                            <TableCell
                                              onClick={() =>
                                                navigate(
                                                  "/customerdetail/" +
                                                    item.customer_id
                                                )
                                              }
                                            >
                                              RM{item.balance}
                                            </TableCell>
                                            {/* <TableCell
                                                                            onClick={() => navigate("/saledetail/" + item.customer_id)}
                                                                        >
                                                                            RM{item.total_amount}
                                                                        </TableCell> */}
                                          </a>
                                        </TableRow>
                                      );
                                    })}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <div
                              style={{
                                borderTop: "1px solid #707070",
                                borderBottom: "1px solid #707070",
                                margin: "1rem 0 0",
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                              }}
                            >
                              <TablePagination
                                // variant="outlined"
                                color="primary"
                                page={pageNum}
                                onPageChange={handleChangePage}
                                count={totalList}
                                // defaultPage={pageList}
                                rowsPerPage={10}
                                rowsPerPageOptions={[10]}
                                // count={10}
                              />
                            </div>
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                    )}
                    {page === "Sales Report" && (
                      <>
                        <div>
                          <div className={classes.theFlexHeader}>
                            <div
                              className={classes.theFlexBtn}
                              style={{ marginBottom: "0" }}
                            ></div>
                          </div>

                          <div className={classes.theFlexAction}>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleSearchSaleReport}
                                value={searchKey}
                              />
                            </div>
                            {/* <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                            
                              <FormInputSelect>
                                <Select
                                  displayEmpty
                                  inputProps={{
                                    "aria-label": "Without label",
                                  }}
                                  value={selectedStatus}
                                  onChange={handleChooseStatus}
                                >
                                  {returnStatus != null &&
                                    returnStatus.map((res) => (
                                      <MenuItem value={res.status}>
                                        {res.status}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormInputSelect>
                            </div> */}
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 0" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleChangeDateFrom}
                                value={dateFrom}
                                type="date"
                              />
                            </div>

                            <Paragraph bold="bold" color="#707070">
                              to
                            </Paragraph>
                            <div
                              className={classes.theWx}
                              style={{ margin: "0 20px 0 20px" }}
                            >
                              <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={handleChangeDateTo}
                                value={dateTo}
                                type="date"
                              />
                            </div>
                          </div>

                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={12}>
                              <Card className={classes.theCard}>
                                <TableContainer>
                                  <Table>
                                    <TableHead
                                      style={{ backgroundColor: "#1A5386" }}
                                    >
                                      {/* <TableRow>
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          Return Order ID
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          SO Number
                                        </TableCell>

                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Customer
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Phone
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Reason
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Memo
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Images
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                        </TableCell>
                                      </TableRow> */}
                                      <TableRow>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                        >
                                          Year - Month
                                        </TableCell>

                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Class
                                        </TableCell>
                                        <TableCell
                                          className={classes.theHeadTitle}
                                        >
                                          Amount
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle}
                                        ></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {/* {listData != null &&
                                        listData
                                          .slice(
                                            pageNum * 10,
                                            pageNum * 10 + 10
                                          )
                                          .map((item, index) => {
                                            return (
                                              <TableRow>
                                            
                                                <TableCell
                                                  className={
                                                    classes.theUnderLineLabel
                                                  }
                                                  style={{
                                                    textDecoration: "underline",
                                                    // width: "20%"
                                                  }}
                                                  onClick={() =>
                                                    navigate(
                                                      "/salereturn/" +
                                                        item.sales_order_id +
                                                        "/" +
                                                        item.sales_order_report_id
                                                    )
                                                  }
                                                >
                                                  {item.sales_order_report_id !=
                                                    "" &&
                                                  item.sales_order_report_id !=
                                                    null
                                                    ? item.sales_order_report_id
                                                    : "-"}{" "}
                                                  View &#62;
                                                </TableCell>
                                                <TableCell
                                                >
                                                  {item.sales_order_id != "" &&
                                                  item.sales_order_id != null
                                                    ? item.sales_order_id
                                                    : "-"}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    width: "25%",
                                                  }}
                                                >
                                                  {item.customer != "" &&
                                                  item.customer != null
                                                    ? item.customer
                                                    : "-"}
                                                </TableCell>

                                                <TableCell>
                                                  {item.phone != "" &&
                                                  item.phone != null
                                                    ? item.phone
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.reason != "" &&
                                                  item.reason != null
                                                    ? item.reason
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.description != "" &&
                                                  item.description != null
                                                    ? item.description
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.status != "" &&
                                                  item.status != null
                                                    ? item.status
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.images.length > 0 ? (
                                                    <span
                                                      onClick={() =>
                                                        handleOpenVariantImage(
                                                          item.images
                                                        )
                                                      }
                                                      style={{
                                                        textDecoration:
                                                          "underline",
                                                        color: "#1a5386",
                                                      }}
                                                    >
                                                      View &#62;
                                                    </span>
                                                  ) : (
                                                    <span
                                                      style={{
                                                        textDecoration:
                                                          "underline",
                                                        color: "#CCCCCC",
                                                      }}
                                                    >
                                                      View &#62;
                                                    </span>
                                                  )}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          })} */}
                                      {listData != null &&
                                        listData
                                          .slice(
                                            pageNum * 10,
                                            pageNum * 10 + 10
                                          )
                                          .map((item, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell>
                                                  {item.month != "" &&
                                                  item.month != null
                                                    ? item.month
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.class != "" &&
                                                  item.class != null
                                                    ? item.class
                                                    : "-"}
                                                </TableCell>
                                                <TableCell>
                                                  {item.amount != "" &&
                                                  item.amount != null
                                                    ? item.amount
                                                    : "-"}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                <div
                                  style={{
                                    borderTop: "1px solid #707070",
                                    borderBottom: "1px solid #707070",
                                    margin: "1rem 0 0",
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <TablePagination
                                    // variant="outlined"
                                    color="primary"
                                    page={pageNum}
                                    onPageChange={handleChangePageSaleReport}
                                    count={totalListSaleReport}
                                    // defaultPage={pageList}
                                    rowsPerPage={10}
                                    rowsPerPageOptions={[10]}
                                    // count={10}
                                  />
                                </div>
                              </Card>
                              <br />
                              <br />
                            </Grid>
                          </Grid>
                          <br />
                          <br />

                          {imageData != null && (
                            <Dialog
                              onClose={handleCloseVariantImage}
                              open={openVariantImg}
                              fullWidth="true"
                              maxWidth="xl"
                            >
                              <DialogTitle>
                                <Paragraph
                                  color="#1A5386"
                                  bold="600"
                                  size="24px"
                                >
                                  Attached Images
                                </Paragraph>
                              </DialogTitle>
                              <DialogContent>
                                <br />
                                <div className={classes.theSliderVariant}>
                                  <Slider
                                    dots={true}
                                    speed={500}
                                    slidesToShow={4}
                                    slidesToScroll={4}
                                    infinite={infiniteStatus}
                                  >
                                    {imageData.map((res) => (
                                      <div>
                                        <div className={classes.theImageBox}>
                                          <div className={classes.theIBImg}>
                                            <img src={res.image} />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </Slider>
                                </div>
                                <br />
                              </DialogContent>
                            </Dialog>
                          )}
                        </div>
                      </>
                    )}
                    <br />
                    <br />
                  </div>
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
